import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-1_njhHSPiY7",
  ClientId: "6jourt3li139jrdhckl4lfhv20",
};

export default new CognitoUserPool(poolData);
